import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Envío AP-2 · planes de subida (admin). */
export const uploadLimitsService = {
  async getConfig() {
    const res = await axios.get(`${API}/admin/upload-limits`);
    return res.data;
  },
  async saveConfig(config) {
    const res = await axios.put(`${API}/admin/upload-limits`, config);
    return res.data;
  },
  async getUserPlan(userId) {
    const res = await axios.get(`${API}/admin/users/${userId}/upload-plan`);
    return res.data;
  },
  async setUserPlan(userId, plan) {
    const res = await axios.put(`${API}/admin/users/${userId}/upload-plan`, { plan: plan || null });
    return res.data;
  },
};
